module.exports = __webpack_public_path__ + "img/zd-new-4.f4c13e57.svg";